import { Swiper } from 'swiper/react';
import { styled } from '@mui/material';

export const sxStyles = {
  cardSlider: {
    maxWidth: '1320px',
    margin: '0 auto',
    padding: '2.5rem 1.25rem',
    overflowX: 'hidden',
  },
  paginationButton: {
    marginLeft: '0.625rem',
    minWidth: '40px',
  },
  navigateButton: {
    padding: '8px 16px',
    alignSelf: 'center',
  },
};

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  overflow: 'visible',
  position: 'relative',

  '.swiper-pagination-bullet': {
    background: theme.palette.common.white,
    width: '12px',
    height: '12px',
    border: `1px solid ${theme.palette.primary.dark}`,
    opacity: '1',
  },

  '.swiper-pagination-bullet-active': {
    background: theme.palette.primary.dark,
  },

  '.swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '4rem',

    '& > div:first-of-type': {
      boxSizing: 'border-box',
    },

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'start',
    },
  },
}));

export const StyledHeader = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gridColumnGap: '2rem',
  alignItems: 'center',
  marginBottom: '2.25rem',
}));

export const StyledPaginationButtonsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  maxHeight: '48px',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',

  [theme.breakpoints.up('md')]: {
    overflow: 'visible',
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
}));
